export function matchItems<T extends { label: string }>(items: T[], query: string): T[] {
    const q = query.trim().toLowerCase();
    if (!q) return [];

    return items
        .filter((item) => item.label.toLowerCase().includes(q))
        .sort((a, b) => a.label.localeCompare(b.label));
}
